import React from 'react';

// Material
import Drawer from '@material-ui/core/Drawer';

// Components
import TripNavigation from './TripNavigation';

// Styles
import useStyle from './styles';

interface StateProps {
  toggleDrawer(open: boolean, car?: any): (event: any) => void;
  open: boolean;
  tripData: any;
}

type Props = StateProps;

const InfoDrawer: React.FC<Props> = ({ open, toggleDrawer, tripData }) => {
  const classes = useStyle();

  return (
    <Drawer anchor='right' onClose={toggleDrawer(false)} open={open}>
      <div className={classes.drawerContents}>
        <TripNavigation tripData={tripData} />
      </div>
    </Drawer>
  );
};

export { InfoDrawer };
export default InfoDrawer;
